import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

import {
    Text,
    StyledCard,
    StyledCardContent,
    IconButton,
    PlusCircleIcon,
    Progress,
} from '../../index';

const CreditsBalanceCard = ({ data, onClick, loading }) => {
    return (
        <StyledCard>
            <StyledCardContent
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    rowGap: '10px',
                }}
            >
                {loading && <Progress />}
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Text $fontSize="18px" $bold>
                        Credits balance
                    </Text>
                </div>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: '20px',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            columnGap: '25px',
                            flexDirection: 'row',
                        }}
                    >
                        <Text
                            $color="pink"
                            $fontSize="32px"
                            $bold
                            style={{
                                width: '100%',
                                textAlign: 'center',
                            }}
                        >
                            {data?.credits} Credits
                        </Text>
                        <IconButton onClick={onClick}>
                            <PlusCircleIcon fill="black" />
                        </IconButton>
                    </div>
                    <Text $color="gray2" $fontSize="14px">
                        Last updated :{' '}
                        {data.updatedAt && dayjs(data.updatedAt).format('DD MMM YYYY')}
                    </Text>
                </div>
            </StyledCardContent>
        </StyledCard>
    );
};

CreditsBalanceCard.propTypes = {
    data: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    onClick: PropTypes.func,
};

export default CreditsBalanceCard;
